import { gql } from "@apollo/client";

export const MEMBER_SEARCH = gql`
  query MemberSearch(
    $pagination: PaginationInput!
    $filter: PathwaysMemberFilterInput!
  ) {
    PathwaysMembersSearch(pagination: $pagination, filter: $filter) {
      _id
      memberId
      memberPolicyId
      name
      dob
      gender
      healthplanCode
      healthplanName
      lineOfBusiness
      ipaCode
      memberIdOthers {
        mpi
        mbi
      }
    }
  }
`;

export interface MemberSearchInput {
  firstName?: string;
  lastName?: string;
  mpi?: string;
  dob?: string;
  /** Include termed / inactive enrollments (drops the active-only filter). */
  showIneligibleMembers?: boolean;
}

export interface MemberSearchVars {
  pagination: { limit: number; skip: number };
  filter: {
    /**
     * Name matching goes through this exact-match pair. The filter also has a
     * single `name` field, but PathwaysMembersSearch does not read it — sending
     * a name there yields a search with no criteria and an empty result set.
     */
    firstName?: string;
    lastName?: string;
    dob?: string;
    memberId?: string;
    isSearch?: boolean;
    showIneligibleMembers?: boolean;
  };
}

export interface MemberSearchResult {
  _id: string;
  memberId?: string;
  memberPolicyId?: string;
  name?: string;
  dob?: string;
  gender?: string;
  healthplanCode?: string;
  healthplanName?: string;
  lineOfBusiness?: string;
  ipaCode?: string;
  memberIdOthers?: { mpi?: string; mbi?: string };
  /**
   * Provider Portal–only fields, present when this result came from the PP
   * member search (`_id` is `pp:<companyId>:<mpi>`). Carried into the full
   * Member 360 profile via react-router `location.state` so the profile can
   * build the PP patient object without a Pathways MEMBER_BY_ID lookup.
   */
  _pp?: {
    companyId: string;
    membMpiNo: string;
    membKeyId?: string | null;
    membId?: string | null;
    fullName?: string | null;
    startDate?: string | null;
    /**
     * Health plan code (PP's `RmiHpCode`) — NOT the IPA/tenant `companyId`.
     * Required (non-empty) by `ClaimMember/CreateClaim` and read by the Create
     * Claim entry gate's health-plan block rules.
     */
    healthPlanCode?: string | null;
  };
}
